import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/es/storage/session";
import { createTransform } from "redux-persist";
import CryptoJS from 'crypto-js';

//Imported all reducers
import userReducer from "./user/user.reducer";
import commonReducer from "./common/common.reducer";
import registraionReducer from "./registration/registration.reducer";
import auctionReducer from "./auctions/auctions.reducer";

//Encryption Key For Reducer Encryption
// const encryptor: any = encryptTransform({
//   secretKey:
//     process.env.REACT_APP_ENCRYPTION_KEY ||
//     `${Math.floor(Math.random() * (100000 - 10000 + 1) + 10000)}`,
//   onError: function (error) {
//     console.log(error);
//   },
// });
const encryptor: any = createTransform(
  // Transform state before saving (encrypt)
  (inboundState, key) => {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(inboundState),
      "my-secret-key"
    ).toString();
    return encrypted;
  },
  // Transform state when loading (decrypt)
  (outboundState, key) => {
    const bytes = CryptoJS.AES.decrypt(outboundState, "my-secret-key");
    const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decrypted;
  }
);

//Persistance configuration Setup Values
const persistConfig = {
  key: "root",
  storage: sessionStorage,
  whitelist: ["user", "common"],
  transforms: [encryptor],
};

//Combining all reducers to a single reducer
const rootReducer = combineReducers({
  user: userReducer,
  common: commonReducer,
  registraionReducer: registraionReducer,
  auction: auctionReducer,
});

//Exporting encrypted Reducer Data- using third party library
export default persistReducer(persistConfig, rootReducer);
